import { SwitchProductModule } from '@wix/package-picker-sdk';
import { useCurrentModule } from '../../components/ModuleProvider';
export const useValidateCycle = () => {
  const module = useCurrentModule();
  const selectedCycle = module.SDK.PackagePickerStore.useSelectedCycle();
  const selectedProductId = module.SDK.PackagePickerStore.useSelectedProductId();
  const {
    data: isCycleAvailableData,
    isLoading: isCycleAvailabilityLoading
  } = SwitchProductModule.SDK.switchApiClient.hooks.useIsCycleAvailable({
    productId: selectedProductId || '',
    cycle: selectedCycle || {}
  });
  return {
    valid: isCycleAvailableData == null ? void 0 : isCycleAvailableData.isCycleAvailable,
    isLoading: isCycleAvailabilityLoading
  };
};
//# sourceMappingURL=useValidateCycle.js.map